// extracted by mini-css-extract-plugin
export var externalLink = "_dh-0";
export var internalLinkLabel = "_dh-1";